var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.22 19.03C13.0795 18.8894 13.0007 18.6988 13.0007 18.5C13.0007 18.3013 13.0795 18.1107 13.22 17.97L18.19 13H3.75C3.55109 13 3.36032 12.921 3.21967 12.7804C3.07902 12.6397 3 12.4489 3 12.25C3 12.0511 3.07902 11.8603 3.21967 11.7197C3.36032 11.579 3.55109 11.5 3.75 11.5H18.19L13.22 6.53003C13.1213 6.43835 13.0491 6.32175 13.0111 6.1925C12.9731 6.06325 12.9706 5.92615 13.004 5.79562C13.0374 5.6651 13.1053 5.54599 13.2007 5.45085C13.2961 5.35571 13.4154 5.28806 13.546 5.25503C13.6764 5.22172 13.8133 5.2241 13.9425 5.26193C14.0716 5.29976 14.1882 5.37164 14.28 5.47003L20.53 11.72C20.6705 11.8607 20.7493 12.0513 20.7493 12.25C20.7493 12.4488 20.6705 12.6394 20.53 12.78L14.28 19.03C14.1394 19.1705 13.9488 19.2494 13.75 19.2494C13.5512 19.2494 13.3606 19.1705 13.22 19.03Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.3c0c3c49.svg";
export { ForwardRef as ReactComponent };